<template>
  <div>
    <div class="text-xl font-black py-2 mt-8">2. Market Share Assessment</div>
    <div class="font-black py-2">Competitive Landscape Report</div>
    <div class="flex w-full items-center">
      <div class="flex-1/3 px-4">
        <div class="py-2">Competitive Landscape Report. Screen shot gathered from the 'Competitor Analysis Tool' for your offices 'Area of Membership' covering 24-12 months ago.</div>
        <panel class="img-div" v-if="form.attachment && form.attachment.region_landscape_img">
          <img :src="form.attachment.region_landscape_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="LandscapeImgVisible=true" />
          <modal v-if="LandscapeImgVisible" @leave="LandscapeImgVisible=false" modalClass="max-width-full">
            <img :src="form.attachment.region_landscape_img" />
          </modal>
        </panel>
        <panel v-else>
          <div>
            <img src="https://via.placeholder.com/400x200.png?text=No+region+lanscape+image">
          </div>
        </panel>
      </div>
      <div class="flex-1/3 px-4">
        <div class="py-2">Competitive Landscape Report. Screen shot gathered from the 'Competitor Analysis Tool' for your offices 'Area of Membership' covering the last 12 months.</div>
        <panel class="img-div" v-if="form.attachment && form.attachment.territory_landscape_img">
          <img :src="form.attachment.territory_landscape_img" class="w-full pb-2 object-cover bg-gray-100 cursor-pointer" @click="TerritoryImgVisible=true" />
          <modal v-if="TerritoryImgVisible" @leave="TerritoryImgVisible=false" modalClass="max-width-full">
            <img :src="form.attachment.territory_landscape_img" />
          </modal>
        </panel>
        <panel v-else>
          <div>
            <img src="https://via.placeholder.com/400x200.png?text=No+postcode+territories+lanscape+image">
          </div>
        </panel>
      </div>
    </div>
    <!-- Sub section -->
    <div class="mt-8 pt-2">
      <div class="mb-4">
        <div>Market share & competitor analysis: </div>
        <div class="pt-2">
          <div class="flex w-full justify-between">
            <div class="flex-grow py-2"></div>
            <div class="w-1/6 border-l border-r px-4 mr-2 text-center">24-12 Months Ago</div>
            <div class="w-1/6 px-4 text-center">Last 12 Months</div>
          </div>
          <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
            <hr class="border-b my-8" />
            <review-question-component v-model="form.questions[page][sectionStart][index]" column-class="w-1/6 flex justify-between" input-class="mb-0" :showMandatory="showMandatory"></review-question-component>
          </div>
        </div>
        <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
          <hr class="border-b my-8" />
          <review-question-component v-model="form.questions[page][sectionStart+1][index2]" column-class="w-1/6 flex justify-between" input-class="mb-0" :showMandatory="showMandatory"></review-question-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      errors: [],
      LandscapeImgVisible: false,
      TerritoryImgVisible: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
  .img-div{
    width: 80%;
    border: 2px dotted grey;
  }
</style>
